import * as echarts from 'echarts';
// import { afterTodaySomeDay, getDateList } from './calculate7days'
// let dateArray = getDateList(afterTodaySomeDay(0))
let doubleLineOption = {
    tooltip: {
        trigger: 'axis'
    },
    grid: {
        top: '10%',
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: [0],
        axisLine: {
            lineStyle: {
                color: '#B3B3B3'
            }
        },
        axisLabel: {
            rotate: 0
        },
    },
    yAxis: {
        type: 'value',
        splitNumber: 5,
        axisLine: {
            lineStyle: {
                color: '#B3B3B3'
            }
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: ['#315070'],
                type: 'dashed'
            }
        }
    },
    series: [
        {
            name: '3天熟料强度',
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
            smooth: true,
            itemStyle: {
                normal: {
                    color: '#13BCFE',
                    borderColor: '#65FA8E',
                }
            },
            data: [0]
        },
        {
            name: '28天熟料强度',
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
            smooth: true,
            itemStyle: {
                normal: {
                    color: '#2361F4',
                    borderColor: '#65FA8E',
                }
            },
            data: [0]
        },

    ]
};

export { doubleLineOption }


// WEBPACK FOOTER //
// ./src/components/home/centerBottom/doubleLineOption.js